import { AppConfig } from '../../../common/model/config';
import { arabiaTheme } from '../themes/arabia.theme';
import { ORDER_TYPE_DELIVERY } from '../../../common/model/order-types';

export const arabiaConfig: AppConfig = {
  appName: 'arabia',
  appTitle: 'Arábia',
  appDescription: 'Peça aqui no Arábia.',
  aggregator: 889,
  brand: 39,
  theme: arabiaTheme,
  faviconPath: '/favicons/favicon-arabia.ico',
  defaultOrderType: ORDER_TYPE_DELIVERY,
  defaultLocation: {
    // Avenida Paulista
    latitude: -23.5631043,
    longitude: -46.6565712,
  },
  featureFlags: {
    embeddedApplication: false,
    getBrandThemeFromBackend: false,
    shuffleCompanyArray: false,
    gmapsAddress: true,
    showOptionsTabsAggregators: false,
    filterByDeliveryArea: true,
    useLocalAggregatorHeaderImg: false,
    removeLogoFromTheApp: true,
  },
};
